import { KeyboardEvent } from "react";

const decimalEntry = (event: KeyboardEvent<HTMLInputElement>) => {
  const input = event.target as HTMLInputElement;
  const allowedKeys = ["Backspace", "Delete", "Tab", "Escape", "Enter", "ArrowLeft", "ArrowRight", "ArrowUp", "ArrowDown", "Home", "End"];
  const hasDecimalSeparator = /[.,]/.test(input.value);
  console.log(event.key);

  if (
    !(event.ctrlKey || event.metaKey) &&
    !allowedKeys.includes(event.key) &&
    !(event.key === "." && !hasDecimalSeparator) &&
    !(event.key === "," && !hasDecimalSeparator) &&
    !/[0-9]/.test(event.key)
  ) {
    event.preventDefault();
  }

  if (event.key === ",") {
    event.preventDefault();
    const selectionStart = input.selectionStart || 0;
    const newValue = input.value.substring(0, selectionStart) + "." + input.value.substring(selectionStart);

    input.value = newValue;
    const ev = new Event("input", { bubbles: true });
    input.dispatchEvent(ev);

    input.setSelectionRange(selectionStart + 1, selectionStart + 1);
  }
};

export default decimalEntry;
